<template>
	<div class="container">
		<!--  顶部基础信息  -->
		<div class="job-title g-flex g-row-center">
			<div class="total-width">
				<div class="g-p-40 g-flex g-row-between">
					<div>
						<p class="g-font-28 g-weight-font">{{ dataInfo.postName }}</p>
						<p class="g-font-14 g-m-t-10 remark-text">
							{{dataInfo.qualifications}}|{{dataInfo.workYear}}年经验|{{dataInfo.num}}人
						</p>
						<div class="g-flex g-m-t-40" v-if="getUserRole&&getUserRole.indexOf('HR')==-1">
							<div class="submit-btn" @click="showResume" v-if="dataInfo.resumeId==-1">投递简历</div>
							<div class="collect-btn g-m-l-20" @click="collectJob" v-if="dataInfo.collectId==-1">收藏职位</div>
							<div class="collect-btn g-m-l-20" @click="cancelCollect" v-else>已收藏</div>
						</div>
					</div>
					<div class="g-text-right">
						<p class="g-font-26 g-weight-font yellow-text">{{ dataInfo.salary }}</p>
						<p class="g-m-t-20 blue-text">{{ dataInfo.cityName }}</p>
					</div>
				</div>
			</div>
		</div>
		<!--  详情/公司信息  -->
		<div class="g-m-t-30 g-flex g-row-center">
			<div class="total-width g-flex g-col-top g-row-between">
				<!--  详情  -->
				<div class="g-rela desc-box">
					<div class="info-row g-rela g-m-t-40">
						<div class="info-tag g-rela">
							<p class="g-p-l-20 g-weight-font">岗位职责</p>
						</div>
						<div class="g-p-l-35">
							<p class="g-font-14 g-m-t-10">{{ dataInfo.responsibilities }}</p>
						</div>
					</div>
					<div class="info-row g-rela g-m-t-40">
						<div class="info-tag g-rela">
							<p class="g-p-l-20 g-weight-font">任职要求</p>
						</div>
						<div class="g-p-l-35">
							<p class="g-font-14 g-m-t-10">{{ dataInfo.requirements }}</p>
						</div>
					</div>
					<!--  工作地址  -->
					<div class="info-row g-rela g-m-t-40">
						<div class="info-tag g-rela">
							<p class="g-p-l-20 g-weight-font">工作地址</p>
						</div>
						<div class="g-p-35">
							<div class="map-box">
								<div class="g-p-15 g-flex">
									<img src="@/assets/find-job/position-icon.png" class="position-icon" alt="">
									<p class="g-m-l-10 g-font-16">{{ hospital.address }}</p>
								</div>
								<div class="g-p-20">
									<div class="map-container" id="map-container"></div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!--  公司信息  -->
				<div class="company-box">
					<div class="company-tag g-m-t-20">
						<div class="g-flex">
							<img src="@/assets/find-job/half-circle.png" class="half-circle" alt="">
							<p class="g-m-l-5 white-text g-font-20 g-weight-font">公司信息</p>
						</div>
					</div>
					<div class="g-p-20">
						<div class="g-flex g-m-t-23 g-col-top">
							<img :src="hospital.avatar?hospital.avatar:require('@/assets/examples/02.png')" class="store-img" alt="">
							<div class="g-m-l-15">
								<p class="g-font-18">{{hospital.name}}</p>
								<div class="g-m-t-10 g-flex g-font-14">
									<p class="blue-text">在招职位：</p>
									<p class="yellow-text">{{hospital.demandNum}}个</p>
								</div>
							</div>
						</div>
						<div class="infos g-m-t-15">
							<div class="g-p-15 g-font-14 remark-text desc">
								{{hospital.brief}}
							</div>
						</div>
						<div class="g-m-t-30 submit-btn" @click="goDetail(hospital.id)">
							查看所有在招职位
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  投递简历弹窗  -->
		<message-popup ref="popup" :showCancel="false" confirmText="知道了" @submit="doSubmit">
			<div class="g-text-center">
				<p class="g-m-t-10 main-text g-font-20">投递成功了!</p>
				<p class="g-m-t-20 remark-text g-font-14">已成功为您投递简历，请留意站内消息。</p>
			</div>
		</message-popup>
		<message-popup ref="popup2" :showCancel="false" confirmText="知道了" @submit="doSubmit2">
			<div class="g-text-center">
				<p class="g-m-t-10 main-text g-font-20">收藏成功了!</p>
			<p class="g-m-t-20 remark-text g-font-14">收藏成功，可在个人中心查看。</p>
			</div>
		</message-popup>
	</div>
</template>

<script>
	import messagePopup from "@/components/message-popup";
	import {
		TMap
	} from '@/utils/TMap'
	import {
		jobDetail,
		hospitalDetail,
		sendResume,
		deleteCollection,
		relationshipSubmit
	} from "@/api/job.js"
	export default {
		name: "job-detail",
		components: {
			messagePopup
		},
		data() {
			return {
				id: '',
				TMap: null,
				dataInfo: {},
				hospital: {

				},
				mapKey: 'VCLBZ-MGTL3-FXJ3U-3J5Q4-VMOH7-PZBO4'
			}
		},
		computed: {
			getUserRole() {
				return this.$store.state.userInfo.role_name
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			collectJob(){
				relationshipSubmit({
					businessId:this.id,
					businessType:0
				}).then(res=>{
					this.getDetail()
					this.$refs.popup2.open()
				})
			},
			// 取消收藏
			cancelCollect(id) {
				deleteCollection({
					id:this.dataInfo.collectId
				}).then(res=>{
					this.getDetail()
				})
			},
			// 投递简历确定事件
			doSubmit() {
				this.$refs.popup.close()
			},
			doSubmit2(){
				this.$refs.popup2.close()
			},
			// 点击投递简历
			showResume() {
				if(!this.$store.state.isLogin) {
					this.$router.push({name:'login'});
				} else if(this.$store.state.userInfo.resumeId==-1) {
					this.$message.warning('请先完善个人简历信息');
					this.$router.push({name:'mine',query:{menuIndex:2}});
				} else {
					let params = {
						orgId: this.dataInfo.clinicId,
						orgName: this.dataInfo.clinicName,
						employPostId: this.dataInfo.postId,
						employPostName: this.dataInfo.postName,
						type:0,
						status: 0
					}
					sendResume(params).then(res => {
						this.$refs.popup.open()
					})
				}
			},
			getDetail() {
				jobDetail({
					id: this.id
				}).then(res => {
					console.log(res)
					this.dataInfo = res
					hospitalDetail({
						id: res.clinicId
					}).then(res => {
						this.hospital = res
						this.initMap(res.latitude, res.longitude);
					})
				})
			},
			initMap(lat, lng) {
				TMap(this.mapKey).then(qq => {
					let center = new qq.maps.LatLng(lat, lng);
					let map = new qq.maps.Map(document.getElementById("map-container"), {
						// 地图的中心地理坐标
						center: center,
						//初始化地图缩放级别
						zoom: 15
					});
					//添加提示窗
					let infoWin = new qq.maps.InfoWindow({
						map: map
					});
					//添加标记
					let marker = new qq.maps.Marker({
						position: center,
						map: map,
					})

				})
			},
			goDetail(id) {
				this.$router.push({
					path: 'store-detail',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	$btn-padding: 8px 32px;

	.job-title {
		background: #fff;

		.submit-btn {
			padding: $btn-padding;
			margin: 0;
		}
	}



	.collect-btn {
		padding: $btn-padding;
		border: 1px solid #407aff;
		border-radius: 5px;
		color: #407aff;

		&:hover {
			background: #407aff;
			color: #fff;
		}
	}

	.desc-box {
		width: 850px;
		background: #ffffff;
		border-radius: 5px;
	}

	.info-tag {
		width: 189px;
		height: 54px;
		line-height: 54px;
		text-align: center;
		background-image: url("../../assets/find-job/desc-tag.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-left: -10px;
		font-size: 18px;
	}

	.map-box {
		background: #ffffff;
		border-radius: 5px;
		box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);

		.map-container {
			width: 100%;
			height: 285px;
		}
	}

	.company-box {
		width: 330px;
		background: #ffffff;
		border-radius: 5px;

		.submit-btn {
			padding: 10px 32px;
			margin: 0;
			letter-spacing: 2px;
		}

	}

	.half-circle {
		width: 10px;
		height: 18px;
	}

	.company-tag {
		padding: 3px 15px 3px 20px;
		border-radius: 0 20px 20px 0;
		color: #fff;
		background: #407aff;
		display: inline-block;
	}

	.store-img {
		width: 78px;
		height: 78px;
		border-radius: 10px;
	}

	.infos {
		background: #f6f6f8;
		border-radius: 5px;
	}


	.desc {
		letter-spacing: 1px;
		line-height: 20px;
	}
</style>
